import { render } from "./MobileNotes.vue?vue&type=template&id=d8bc6a1e&scoped=true"
import script from "./MobileNotes.vue?vue&type=script&lang=js"
export * from "./MobileNotes.vue?vue&type=script&lang=js"

import "./MobileNotes.vue?vue&type=style&index=0&id=d8bc6a1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8bc6a1e"]])

export default __exports__